import { useEffect, useRef, useState } from 'react'
import { createPortal } from 'react-dom'
import { supabase } from '../lib/supabase.js'
import { downloadInvoicePdf, downloadOrderPdf, downloadQuotePdf } from '../lib/documentPdf.js'

const ROUTES={
  quotes:{table:'quotes',numberColumn:'quote_number',kind:'quote'},
  orders:{table:'orders',numberColumn:'order_number',kind:'order'},
  invoices:{table:'invoices',numberColumn:'invoice_number',kind:'invoice'}
}

export default function RecordPdfQuickAction({tenantId,route}){
  const[target,setTarget]=useState(null),[recordId,setRecordId]=useState(''),[busy,setBusy]=useState(false)
  const lastLookup=useRef('')

  useEffect(()=>{
    const config=ROUTES[route]
    if(!config||!tenantId){setTarget(null);setRecordId('');return}
    let cancelled=false,timer=null

    async function refresh(){
      const headings=[...document.querySelectorAll('.editor-backdrop:not(.top-layer) .editor-panel .editor-head h2')]
      const heading=headings.find(h=>h?.textContent?.trim())
      const number=heading?.textContent?.trim()||''
      const portalTarget=heading?.parentElement||null
      if(!number||!portalTarget){lastLookup.current='';if(!cancelled){setTarget(null);setRecordId('')}return}
      const lookup=`${route}:${number}`
      if(lastLookup.current===lookup&&recordId){if(!cancelled)setTarget(portalTarget);return}
      lastLookup.current=lookup
      const{data,error}=await supabase.from(config.table).select('id').eq('tenant_id',tenantId).eq(config.numberColumn,number).maybeSingle()
      if(cancelled)return
      if(error||!data?.id){setTarget(null);setRecordId('');return}
      setRecordId(data.id);setTarget(portalTarget)
    }

    const schedule=()=>{clearTimeout(timer);timer=setTimeout(refresh,40)}
    const observer=new MutationObserver(schedule)
    observer.observe(document.body,{childList:true,subtree:true,characterData:true})
    schedule()
    return()=>{cancelled=true;clearTimeout(timer);observer.disconnect();lastLookup.current='';setTarget(null);setRecordId('')}
  },[tenantId,route])

  async function download(){
    const config=ROUTES[route]
    if(!config||!recordId||busy)return
    setBusy(true)
    try{
      if(config.kind==='quote')await downloadQuotePdf(tenantId,recordId)
      else if(config.kind==='order')await downloadOrderPdf(tenantId,recordId)
      else await downloadInvoicePdf(tenantId,recordId)
    }catch(e){window.alert(e?.message||'PDF could not be generated.')}
    setBusy(false)
  }

  if(!target||!recordId)return null
  return createPortal(<button type="button" className="accent-action record-pdf-action" disabled={busy} onClick={download}>{busy?'Generating PDF…':'Download PDF'}</button>,target)
}
